import * as THREE from 'three';
import {PerspectiveCamera} from './camera';

export class Bookmark extends THREE.Object3D {
    realPosition: THREE.Vector3;
    target: THREE.Vector3;
    t: number;
    line: THREE.Line;
    circle: THREE.Sprite;
    forceVisible: boolean;

    constructor(name: string, position: THREE.Vector3, target: THREE.Vector3, scale: number = 1.0, forceVisible: boolean = false) {
        super();
        this.name = name;
        this.position.copy(position);
        this.realPosition = new THREE.Vector3().copy(position);
        this.target = new THREE.Vector3().copy(target);
        this.t = 0;
        this.scale.set(scale, scale, scale);
        this.forceVisible = forceVisible;

        let material1 = new THREE.LineBasicMaterial({
            color: 0xffffff,
            linewidth: 3,
        });

        let geometry = new THREE.BufferGeometry().setFromPoints([
            new THREE.Vector3(0.0, -1000000.0, 0.0),
            new THREE.Vector3(0.0, 0.0, 0.0),
        ]);

        this.line = new THREE.Line(geometry, material1);
        this.add(this.line);

        let map = new THREE.TextureLoader().load("assets/eye.png");
        let material2 = new THREE.SpriteMaterial({
            map: map,
            color: 0xfffffff,
            transparent: !this.forceVisible,
        });
        this.circle = new THREE.Sprite(material2);
        this.add(this.circle);
    }

    setOpacity(opacity: number) {
        if (this.forceVisible) {
            return;
        }

        if (opacity < 0.05) {
            this.visible = false;
        } else if (opacity > 0.95) {
            this.visible = true;
            this.traverse((model: THREE.Object3D) => {
                if (model instanceof THREE.Mesh) {
                    model.material.transparent = false;
                    model.material.opacity = 1;
                }
            });
        } else {
            this.traverse((model: THREE.Object3D) => {
                if (model instanceof THREE.Mesh) {
                    model.material.transparent = true;
                    model.material.opacity = opacity;
                }
            });
        }
    }

    length() {
        return 15 * (Math.cos(this.t) + 5);
    }

    update(camera: PerspectiveCamera) {
        // Find distance between camera and bookmark.
        let position = this.localToWorld(new THREE.Vector3(0, 0, 0));
        let distance = position.distanceTo(camera.position);

        const min = 10.0;
        const max = 50.0;
        this.setOpacity((distance - min) / (max - min));

        this.t += 0.05;

        let l = this.length();
        this.circle.scale.x = l * Math.log(1 + distance);
        this.circle.scale.y = l * Math.log(1 + distance);
        this.circle.scale.z = l * Math.log(1 + distance);

        this.circle.lookAt(camera.position.clone());
    }
}
